import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment';
import { HttpClient } from '@angular/common/http';
import { TypeChantier } from '../model/typeChantier.model';
import { ConfigService } from './config.service';
import { Rugosite } from '../model/rugosite.model';

@Injectable({
    providedIn: 'root',
})
export class RugositeService {

    constructor(
        protected http: HttpClient,
        private config: ConfigService
    ) {}

    getRugosites(): Observable<Rugosite[]> {
        return this
            .http
            .get<Rugosite[]>(this.config.apiEndpoint + environment.rugosite_get_collection);
    }
}
